import { Breadcrumb, Col, Row, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import Title from "../UI/Title/Title";
import PriceList from "./PriceLists";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { getPriceLists } from "../../api/priceLists";
import AddPrice from "./AddPrice";
import { PriceListsInterface } from "./Interfaces";

const Price = () => {
  const { RangePicker } = DatePicker;
  const { t } = useTranslation("common");
  const [searchText, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(0);
  const [pickerDate, setPickerDate] = useState({ startDate: '', endDate: '' });
  const [saleLists, setSaleLists] = useState<PriceListsInterface[]>([])
  const [saleListsSearch, setSaleListsSearch] = useState<PriceListsInterface[]>([])

  const [page, setPage] = useState<number>(1);
  const [isAddPriceOpen, setIsAddPriceOpen] = useState(false);

  const { mutateAsync: getPriceListsMutation, isLoading } = useMutation(
    "bills",
    ({ search, page }: { search: string; page: number }) =>
      getPriceLists({ page: page * 10 + 10, q: search, from: pickerDate.startDate, to: pickerDate.endDate }),
    {
      onSuccess: ({ data }) => {
        setSaleListsSearch(data.data)
        setSaleLists(data.data);
      },
    }
  );

  useEffect(() => {
    getPriceListsMutation({ page: page, search: searchText })
  }, [])

  useEffect(() => {
    handleSearch()
  }, [pickerDate, searchText])

  const handleSearch = () => {
    const filteredData = saleListsSearch.length > 0 ? saleListsSearch : saleLists;
    const filteredList = filteredData.filter(item => {
      let nameMatch = item.name.toLowerCase().includes(searchText.trim().toLowerCase());
      const dateMatch =
        (!pickerDate.startDate || pickerDate.startDate <= item.endDate) &&
        (!pickerDate.endDate || pickerDate.endDate >= item.startDate);
      return nameMatch && dateMatch;
    });
    setSaleLists(filteredList);
  };

  const handleDatePicker = (dates: any, stringDates: any) => {
    setPickerDate({
      startDate: stringDates[0],
      endDate: stringDates[1]
    })
  }

  const handleResetFilters = () => {
    if (!pickerDate.startDate && !pickerDate.endDate && !searchText) return
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
    setPickerDate({
      startDate: '',
      endDate: ''
    })
  };

  const handleAddList = () => {
    setIsAddPriceOpen(true)
  }

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col offset={1}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{t("price-List")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("price-List")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={searchText}
            onChange={(e: any) => setSearchText(e.target.value)}
          />
        </Col>
        <Col span={4}>
          <RangePicker
            size="large"
            key={tableKey}
            format={"DD/MM/YYYY"}
            onChange={(dates, stringDates) => {
              handleDatePicker(dates, stringDates)
            }}
          />
        </Col>
        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          offset={12}
          span={2}
        >
          <Col>
            <ResetButton
              onClick={() => {
                handleResetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => handleAddList()} />
        </Col>
        <Col offset={1} span={22}>
          <PriceList tableKey={tableKey}
            saleLists={saleLists}
            setSaleLists={setSaleLists}
            isLoadingProp={isLoading}
            setSaleListsSearch={setSaleListsSearch}
          />
        </Col>
      </Row>
      <AddPrice isAddPriceOpen={isAddPriceOpen} setIsAddPriceOpen={setIsAddPriceOpen} setSaleLists={setSaleLists} setSaleListsSearch={setSaleListsSearch} />
    </>
  );
};

export default Price;
